import { ReactNode } from 'react'

interface DocumentSubtitleProps {
  children: ReactNode
}

const DocumentSubtitle = ({ children }: DocumentSubtitleProps) => (
  <span className="c-block c-text-[10px] c-leading-[14px] c-text-black c-opacity-40">{children}</span>
)

export { DocumentSubtitle }
